export default "__VITE_ASSET__BpOYLH47__"